import { SizeType } from "shared/src/types";
import cx from "components/src/utils/cx";
import { Icon } from "../../Icon/Icon";
import { parseImage } from "shared/src/utils/parseImage";

const marginOffsetList: SizeType[] = ["2xs", "xs", "sm", "md", "lg", "xl"];
const avatarPositionClasses = "cui-relative cui-z-[1]";

const topClasses: Record<string, string> = {
  "2xs": "cui-top-1px",
  xs: "cui-top-1px",
  sm: "cui-top-1px",
  md: "cui-top-1px",
  lg: "cui-top-2px",
  xl: "cui-top-1",
  "2xl": "cui-top-1",
  "3xl": "cui-top-2",
  "4xl": "cui-top-3",
  "5xl": "cui-top-3",
};


const adjustedSizeMap = {
    "5xl": 56,
    "4xl": "3xl",
    "3xl": 32,
    "2xl": "xl",
    "xl": "md",
    "lg": "sm",
    "md": "xs",
    "sm": "2xs",
    "xs": "2xs",
    "2xs": "2xs"
};

function calcImageSize(size) {
    if (typeof size === "number") return size //return Math.round(size * .2);
    if (typeof size === "string") {
        return adjustedSizeMap[size]
    }
}

export const resolveAvatarImage = ({
  icon,
  iconColor,
  altText,
  mode,
  src,
  of,
  size,
  sizeClasses,
  showBorder
}) => {

  const iconProps = { color: iconColor ? iconColor : undefined, size: showBorder ? calcImageSize(size) : size, mode, accessibilityLabel: altText, className: "cui-z-[1]" };
  !iconProps.color && delete iconProps.color;

  const image = parseImage(icon, iconProps);
  
  if (image) return image;

  // All Avatars with a src property
  if (src) {
    return (
      <div
        className={cx(
          {
            [sizeClasses as string]: !!size,
            "-cui-ml-1px": marginOffsetList.includes(size),
          },
          `${avatarPositionClasses} cui-p-2px cui-aspect-auto cui-object-contain`
        )}
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize: "auto 100%",
          backgroundPosition: "50%",
          backgroundRepeat: "no-repeat",
        }}
      />
    );
  }
  // Default to ui_person
  return (
    <Icon
      name="ui_person"
      color="fg-moderate"
      className={cx(
        {
          [topClasses[size]]: true,
          "-cui-ml-1px": marginOffsetList.includes(size),
        },
        `${avatarPositionClasses}`
      )}
      size={size}
    />
  );
};

// const AvatarIcon = ({
//     src,
//     size = "2xl",
//     sizeMap,
//     sizeClasses,
//     of,
//     icon,
//     iconColor,
//     logoName,
//     bgColor,
//     team,
//     country,
//     isCountry,
//     league,
//     teamColorPrimary,
//     altText,
//     sport,
//     mode
//   }: Partial<AvatarProps> & {
//     teamColorPrimary?: string;
//     league?: string,
//     sizeClasses?: string;
//     logoName?: string;
//     sizeMap?: { width: number; height: number } | undefined;
//   }) => {
//     const teamName = typeof team === "object" ? team.name : team;
//     const isDraw = drawTieTeams.includes(teamName?.toLowerCase() || "");

//     // All Avatars with a src property
//     if (src) {
//       return (
//         <div
//           className={cx(
//             {
//               [sizeClasses as string]: !!size,
//               "-cui-ml-1px": marginOffsetList.includes(size)
//             },
//             `${avatarPositionClasses} cui-p-2px cui-aspect-auto cui-object-contain`
//           )}
//           style={{
//             backgroundImage: `url(${src})`,
//             backgroundSize: "auto 100%",
//             backgroundPosition: "50%",
//             backgroundRepeat: "no-repeat"
//           }}
//         />
//       );
//     }

//     // All Avatars with a passed Icon, or a team that's also a country, or is a "Draw" competitor
//     if (icon || (team && isCountry) || !!country || isDraw || league === "countries" ) {

//       const foundCountry = country !== undefined ? getTeamInfo(country) || getTeamInfo(`countries-${country?.toLowerCase()}`) : null;
//       const _iconName = isDraw && !icon ? "icon_ui_neutral_ban" : (icon || (team && isCountry ? getTeamInfo(team as string)?.name : team ) || foundCountry?.name || country) as string;
//       const iconProps = {
//         className: cx({
//           "-cui-ml-1px": marginOffsetList.includes(size)
//         },`${avatarPositionClasses}`),
//         color: iconColor ? iconColor : "fg-moderate",
//         name: _iconName,
//         mode,
//         size: sizeMap && "width" in sizeMap
//         ? sizeMap.width - sizeMap.width * 0.3
//         : 0
//       }

//       let _icon = Icon(iconProps);
//       let flagPlaceholder: React.ReactNode = <Icon {...iconProps} name="flag_placeholder"/>;
//       return (_icon ? _icon : !!country ? flagPlaceholder : null) as JSX.Element;

//     }
//     // Otherwise try to render the TeamLogo
//     if (!src && of === "athlete" || of === "logo") {
//       const teamProps = typeof team === "object" && "name" in team ? {...team, name: logoName } : { name: logoName };
//       return (
//         <TeamLogo
//           {...teamProps}
//           className={`cui-relative cui-z-[1]`}
//           mode={mode}
//           sport={sport}
//           size={
//             sizeMap && "width" in sizeMap
//               ? sizeMap.width - sizeMap.width * 0.2
//               : 0
//           }
//         />
//       );
//     }
//     // Default to ui_person
//     return (
//       <Icon
//         name="ui_person"
//         color="fg-moderate"
//         className={cx({
//           [topClasses[size]]: true,
//           "-cui-ml-1px": marginOffsetList.includes(size)
//         },`${avatarPositionClasses}`)}
//         size={size}
//       />
//     );
//   };

//   function pickColor(bgColor: string, teamColor: string, hasTeam: boolean) {
//     if ((!bgColor || bgColor === "team") && hasTeam && teamColor) {
//       return `${teamColor}`;
//     } else if (bgColor in colors) {
//       return colors[bgColor];
//     } else {
//       return "var(--bg-layer-two)";
//     }
//   }
